import rethrowIfNotAborted from "apollo/rethrowIfNotAborted";
import Box from "ds/components/Box";
import { VcsIntegration } from "types/generated";
import PageInfoHeader from "ds/components/PageInfoHeader";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import { Magnify } from "components/icons/generated";
import { VCS_INTEGRATION_DETAILS_UNION } from "constants/vcsProviders";

import { useTestVCSIntegration } from "../../useTestVCSIntegration";
import StatusCheckSkeleton from "./Skeleton";
import StatusCheckItem from "./Item";
import styles from "./styles.module.css";

type VCSIntegrationTroubleshootingStatusCheckProps = {
  integration: VcsIntegration;
};

const VCSIntegrationTroubleshootingStatusCheck = ({
  integration,
}: VCSIntegrationTroubleshootingStatusCheckProps) => {
  const { testVCSIntegration, loading, data } = useTestVCSIntegration();

  const handleTestIntegration = () => {
    testVCSIntegration({
      variables: {
        id: integration.id,
        provider: integration.provider,
      },
    }).catch(rethrowIfNotAborted);
  };

  const appUrl =
    integration.details?.__typename === VCS_INTEGRATION_DETAILS_UNION.GITHUB_ENTERPRISE_INTEGRATION
      ? integration.details.appUrl
      : undefined;

  return (
    <div className={styles.sidebar}>
      <PageInfoHeader title="Status checks">
        <Button variant="primary" onPress={handleTestIntegration}>
          Test integration
        </Button>
      </PageInfoHeader>
      <Box align="center" fullHeight padding="large" direction="column" gap="large">
        {loading && <StatusCheckSkeleton />}
        {!loading && !data && (
          <EmptyState
            icon={Magnify}
            title="Run checks to troubleshoot this integration"
            caption="Click Test integration to run a one-time set of diagnostic checks.Results will help you verify if the integration is configured correctly."
          >
            <Button variant="primary" onPress={handleTestIntegration}>
              Test integration
            </Button>
          </EmptyState>
        )}
        {!loading && data && (
          <Box direction="column" gap="large" fullWidth>
            {data.checks.map((check) => (
              <StatusCheckItem
                key={check.type}
                check={check}
                provider={integration.provider}
                appUrl={appUrl}
              />
            ))}
          </Box>
        )}
      </Box>
    </div>
  );
};

export default VCSIntegrationTroubleshootingStatusCheck;
